import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Nevada = () => {
  return (
    <StatePropertyTaxPage
      stateName="Nevada"
      processDescription="Property owners may appeal their assessment by filing a petition with the county board of equalization. Appeals must include evidence supporting the property owner's claimed value and be filed within the statutory deadline."
      noticeOfValueMailed="July"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in July to allow property owners time to review and potentially appeal their assessments."
      valuationAsOfDate="July 1"
      valuationAsOfDateExplanation="Nevada assesses property as of July 1 each year. This mid-year assessment date captures market conditions during the summer season when real estate activity is typically high."
      deadlineExplanation="Property owners typically have 30 days from the notice mailing date to file appeals. The deadline usually falls in August."
    />
  );
};

export default Nevada;